/**
 * Funkcja sprawdzająca czy kod pocztowy jest poprawny. Format kodu to: 99-999
 * @param postalCodeToCheck 
 * @returns 
 */

export const isPostalCodeValid = {
   name: 'isPostalCodeValid',
   message: 'Nieprawidłowa wartość',
   test: (postalCodeToCheck: string | undefined) => {
      if(postalCodeToCheck?.length){
         const postalCodeRegexp = /^[0-9]{2}-[0-9]{3}/g
   
         return postalCodeRegexp.test(postalCodeToCheck)
      }
      else {
         return false
      }
   }
}